import React, { PropTypes } from 'react';
import Check from '../../../components/svg/check';

class LoyaltyPointsSteps extends React.Component {
  static propTypes = {
    points: PropTypes.number.isRequired
  };

  lineLength (min, max) {
    const fraction = (this.props.points - min) / (max - min);
    if (fraction < 0) {
      return 0;
    }
    return fraction > 1 ? 1 : fraction;
  }

  solidLineLength (min, max) {
    const lineLength = this.lineLength(min, max);
    return `${lineLength * 62}px`;
  }

  dottedLineLength (min, max) {
    const lineLength = this.lineLength(min, max);
    return `${62 - (lineLength * 62)}px`;
  }

  solidCircle (levelPoints) {
    return this.props.points >= levelPoints ? ' solid' : '';
  }

  renderCheck (shouldRender) {
    return shouldRender ? <Check width='10' height='10' colorSchema='white' /> : null;
  }

  render () {
    return (<div className='loyalty-points-overview-current-points'>
      <div className={'current-point-circle' + this.solidCircle(0)}>
        {this.renderCheck(this.solidCircle(0))}
      </div>
      <div className='current-point-solid-line' style={{ height: this.solidLineLength(0, 100000) }}></div>
      <div className='current-point-dotted-line' style={{ height: this.dottedLineLength(0, 100000) }}></div>
      <div className={'current-point-circle' + this.solidCircle(100000)}>
        {this.renderCheck(this.solidCircle(100000))}
      </div>
      <div className='current-point-solid-line' style={{ height: this.solidLineLength(100000, 250000) }}></div>
      <div className='current-point-dotted-line' style={{ height: this.dottedLineLength(100000, 250000) }}></div>
      <div className={'current-point-circle' + this.solidCircle(250000)}>
        {this.renderCheck(this.solidCircle(250000))}
      </div>
      <div className='current-point-solid-line' style={{ height: this.solidLineLength(250000, 500000) }}></div>
      <div className='current-point-dotted-line' style={{ height: this.dottedLineLength(250000, 500000) }}></div>
      <div className={'current-point-circle' + this.solidCircle(500000)}>
        {this.renderCheck(this.solidCircle(500000))}
      </div>
      <div className='current-point-solid-line' style={{ height: this.solidLineLength(500000, 1000000) }}></div>
      <div className='current-point-dotted-line' style={{ height: this.dottedLineLength(500000, 1000000) }}></div>
      <div className={'current-point-circle' + this.solidCircle(1000000)}>
        {this.renderCheck(this.solidCircle(1000000))}
      </div>
      <div className='current-point-solid-line' style={{ height: this.solidLineLength(1000000, 1500000) }}></div>
      <div className='current-point-dotted-line' style={{ height: this.dottedLineLength(1000000, 1500000) }}></div>
      <div className={'current-point-circle' + this.solidCircle(1500000)}>
        {this.renderCheck(this.solidCircle(1500000))}
      </div>
    </div>);
  }
}

export default LoyaltyPointsSteps;



/** WEBPACK FOOTER **
 ** ./src/views/loyalty-program/overview/steps.js
 **/